/**
 * UTF-16 Little Endian Encoding.
 *
 * @public
 */
export const UTF_16_LE = 'utf-16le'
